





























































import cartLine from 'library/mixins/cart-line'
import SubscriptionOptIn from 'library/components/global/subscription-opt-in'
export default

	mixins: [ cartLine ]

	data: -> component: @$GTM_COMPONENTS.CART_PAGE

	components: { SubscriptionOptIn }

